import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "w-50 mx-auto" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "btn-group float-end" }

import Layout from '@/components/Layout.vue';
import Navigation from '@/components/Navigation.vue';
import CameraFeed from '@/components/CameraFeed.vue'
import {useHasActiveTest} from "@/hooks/hastest.hook";
import {onBeforeMount} from "vue";
import {useTranslate} from "@/hooks/translate.hook";


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraView',
  setup(__props) {

const t = useTranslate()
async function runAgain() {
  //@ts-ignore
  const status = await navigator.permissions.query({name: "camera"})
  location.reload()
}

const hasTest = useHasActiveTest()
onBeforeMount(() => hasTest())

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navigation),
    _createVNode(Layout, null, {
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)('page.camera.title')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              innerHTML: _unref(t)('page.camera.text.0')
            }, null, 8, _hoisted_4),
            _createElementVNode("p", {
              innerHTML: _unref(t)('page.camera.text.1')
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(CameraFeed, { class: "mb-3" })
            ]),
            _createElementVNode("p", {
              innerHTML: _unref(t)('page.camera.text.2')
            }, null, 8, _hoisted_7),
            _createElementVNode("p", {
              innerHTML: _unref(t)('page.camera.text.3')
            }, null, 8, _hoisted_8),
            _createElementVNode("p", {
              innerHTML: _unref(t)('page.camera.text.4')
            }, null, 8, _hoisted_9),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: runAgain
              }, _toDisplayString(_unref(t)('page.camera.again')), 1),
              _createVNode(_component_RouterLink, {
                to: "/list",
                class: "btn btn-sm btn-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('page.camera.return')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})